import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import Catalogos from './modules/catalogos'
import Seguridad from './modules/seguridad'
import Reclutamiento from './modules/reclutamiento'
import GsEncuesta from './GsEncuesta'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    'app-ecommerce': ecommerceStoreModule,
    catalogos: Catalogos,
    seguridad: Seguridad,
    reclutamiento: Reclutamiento,
    gsencuesta: GsEncuesta,
  },
  strict: process.env.DEV,
})
